import React from 'react';
import { useAuth } from '@workos-inc/authkit-react';
import { getBranding } from '../scripts/branding';
import '../App.css';

const UserProfile = () => {
  const branding = getBranding();

  // Mock user object for development
  const user = {
    id: 'user_01H1J2K3N4P5Q6R7S8T9V0X1Y2',
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    emailVerified: true,
    profilePictureUrl: 'https://example.com/profile.jpg',
    createdAt: '2023-01-01T00:00:00.000Z',
    updatedAt: '2023-01-01T00:00:00.000Z',
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={branding.logo} className="App-logo" alt="logo" />
        <h1>User Profile</h1>
        <table className="user-profile-table">
          <tbody>
            {Object.entries(user).map(([key, value]) => (
              <tr key={key}>
                <td><strong>{key}</strong></td>
                <td>{String(value)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </header>
    </div>
  );
};

export default UserProfile;
